'use client';

import type { DividerBlock } from '@impact/types';

interface Props {
  block: DividerBlock;
  editing?: boolean;
}

/**
 * Wave variant: SVG wave separator
 */
export function DividerWave({ block: _block, editing: _editing }: Props) {
  return (
    <div className="my-8 overflow-hidden leading-none" aria-hidden="true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 80"
        preserveAspectRatio="none"
        className="w-full h-12 text-border"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M0 40 C200 0, 400 80, 600 40 S1000 0, 1200 40" />
      </svg>
    </div>
  );
}
